import { defineStore } from 'pinia';
import authApi from '../../api/axios-api';
import GlobalRequest from '@/api/global-request';
// import { showToast } from '@/helpers/toast-handler';
const UPLOAD_URL = 'v2/upload';

export const useFileStore = defineStore('file', {
    state: () => ({
        file: {},
        files: [],
        images: [],
    }),
    actions: {
        // Upload files or just a single file
        async uploadFile(url, files) {
            let fileIds = [];
            for (var i = 0; i < files.length; i++) {
                const formData = new FormData();
                formData.append('file', files[i]);
                const response = await authApi.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status == 201) {
                    const fileId = response.data?.data?.id;
                    fileIds.push(fileId);
                }
            }
            return fileIds;
        },
        // for now it will give all the images by a specific user
        async getUploadedImages(user_id = null, company_id) {
            try {
                const response = await GlobalRequest.getRequest(UPLOAD_URL, {
                    params: {
                        userId: user_id,
                        company_id,
                        paginated: false,
                    },
                });
                if (response.message == 'Ok') {
                    this.images = response.data;
                }
            } catch (error) {
                throw new Error('Failed to retrieve user images');
            }
        },
    },
});
